var _desc, _rect, _rect2, _text, _text2, _rect3, _text3, _text4, _rect4, _text5, _rect5, _text6, _rect6, _text7, _rect7, _text8, _rect8, _text9, _rect9, _text0, _rect0, _text1, _g, _g2, _g3, _g4, _g5, _g6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 560 384",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    fontFamily: "Inter, system-ui, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Illustrated view of the Kawnter stock screen") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Active and reserve stock tabs, category filter pills, and an inventory grid where each illustrated product card shows its price, how many remain in stock and an edit action.")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 560,
    height: 384,
    rx: 10,
    fill: "#F4F7F8"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 12,
    width: 266,
    height: 42,
    rx: 9,
    fill: "#4E9A92"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 145,
    y: 30,
    fontSize: 11.5,
    fontWeight: 700,
    fill: "#FFFFFF",
    textAnchor: "middle"
  }, "Active Stocks")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 145,
    y: 44,
    fontSize: 8.5,
    fill: "#CFE8E3",
    textAnchor: "middle"
  }, "On the shelf \u2014 what sales draw on")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 286,
    y: 12,
    width: 262,
    height: 42,
    rx: 9,
    fill: "#FFFFFF",
    stroke: "#E9EFF2"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 417,
    y: 30,
    fontSize: 11.5,
    fontWeight: 700,
    fill: "#14344B",
    textAnchor: "middle"
  }, "Reserve Stocks")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 417,
    y: 44,
    fontSize: 8.5,
    fill: "#8AA0AE",
    textAnchor: "middle"
  }, "Unopened packs in the storeroom")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 64,
    width: 39,
    height: 26,
    rx: 13,
    fill: "#4E9A92",
    stroke: "none"
  })), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 31,
    y: 81,
    fontSize: 10,
    fontWeight: 600,
    fill: "#FFFFFF",
    textAnchor: "middle"
  }, "All")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 57.6,
    y: 64,
    width: 57,
    height: 26,
    rx: 13,
    fill: "#FFFFFF",
    stroke: "#E9EFF2"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 86,
    y: 81,
    fontSize: 10,
    fontWeight: 600,
    fill: "#14344B",
    textAnchor: "middle"
  }, "Drinks")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 121.80000000000001,
    y: 64,
    width: 51,
    height: 26,
    rx: 13,
    fill: "#FFFFFF",
    stroke: "#E9EFF2"
  })), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 147,
    y: 81,
    fontSize: 10,
    fontWeight: 600,
    fill: "#14344B",
    textAnchor: "middle"
  }, "Foods")), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 179.8,
    y: 64,
    width: 57,
    height: 26,
    rx: 13,
    fill: "#FFFFFF",
    stroke: "#E9EFF2"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 208,
    y: 81,
    fontSize: 10,
    fontWeight: 600,
    fill: "#14344B",
    textAnchor: "middle"
  }, "Snacks")), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 244,
    y: 64,
    width: 63,
    height: 26,
    rx: 13,
    fill: "#FFFFFF",
    stroke: "#E9EFF2"
  })), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 276,
    y: 81,
    fontSize: 10,
    fontWeight: 600,
    fill: "#14344B",
    textAnchor: "middle"
  }, "Candies")), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 314.4,
    y: 64,
    width: 76,
    height: 26,
    rx: 13,
    fill: "#FFFFFF",
    stroke: "#E9EFF2"
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 352,
    y: 81,
    fontSize: 10,
    fontWeight: 600,
    fill: "#14344B",
    textAnchor: "middle"
  }, "Medicines")), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 401,
    y: 64,
    width: 143,
    height: 26,
    rx: 13,
    fill: "#FFFFFF",
    stroke: "#E9EFF2"
  })), _text1 || (_text1 = /*#__PURE__*/React.createElement("text", {
    x: 415,
    y: 81,
    fontSize: 9.5,
    fill: "#9BAFBC"
  }, "Search name or description\u2026")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12,100)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 124,
    rx: 11,
    fill: "#FFFFFF",
    stroke: "#E9EFF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 9,
    width: 150,
    height: 56,
    rx: 8,
    fill: "#F7FAFB"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(85,38)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13,-27)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 0,
    width: 20,
    height: 9,
    rx: 3,
    fill: "#1D5A85"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 8,
    width: 16,
    height: 6,
    rx: 2,
    fill: "#C4D7E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 13 h18 a4 4 0 0 1 4 4 v30 a7 7 0 0 1 -7 7 h-12 a7 7 0 0 1 -7 -7 v-30 a4 4 0 0 1 4 -4z",
    fill: "#EDF4F8",
    stroke: "#C4D7E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 24,
    width: 24,
    height: 17,
    rx: 2,
    fill: "#2E9B9B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 29,
    width: 13,
    height: 3,
    rx: 1.5,
    fill: "#fff",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 34,
    width: 8,
    height: 2.5,
    rx: 1.2,
    fill: "#fff",
    opacity: 0.6
  }))), /*#__PURE__*/React.createElement("text", {
    x: 12,
    y: 82,
    fontSize: 12,
    fontWeight: 600,
    fill: "#14344B"
  }, "Pocari sweat"), /*#__PURE__*/React.createElement("text", {
    x: 12,
    y: 98,
    fontSize: 13,
    fontWeight: 700,
    fill: "#14344B"
  }, "\u20B140"), /*#__PURE__*/React.createElement("text", {
    x: 158,
    y: 98,
    fontSize: 9.5,
    fill: "#8AA0AE",
    textAnchor: "end"
  }, "46 in stock"), /*#__PURE__*/React.createElement("path", {
    d: "M10 106 H160",
    stroke: "#E9EFF2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 85,
    y: 118,
    fontSize: 9.5,
    fontWeight: 600,
    fill: "#8AA0AE",
    textAnchor: "middle"
  }, "Edit"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(195,100)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 124,
    rx: 11,
    fill: "#FFFFFF",
    stroke: "#E9EFF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 9,
    width: 150,
    height: 56,
    rx: 8,
    fill: "#F7FAFB"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(85,38)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-13,-27)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 0,
    width: 12,
    height: 8,
    rx: 2.5,
    fill: "#E4813F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 8 h18 a4 4 0 0 1 4 4 v35 a7 7 0 0 1 -7 7 h-12 a7 7 0 0 1 -7 -7 v-35 a4 4 0 0 1 4 -4z",
    fill: "#8FCBE8",
    stroke: "#6FAFCF",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 22,
    width: 24,
    height: 18,
    rx: 2,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 31 q7 -7 14 0",
    stroke: "#E4813F",
    strokeWidth: 3,
    fill: "none",
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("text", {
    x: 12,
    y: 82,
    fontSize: 12,
    fontWeight: 600,
    fill: "#14344B"
  }, "Gatorade 500ml"), /*#__PURE__*/React.createElement("text", {
    x: 12,
    y: 98,
    fontSize: 13,
    fontWeight: 700,
    fill: "#14344B"
  }, "\u20B160"), /*#__PURE__*/React.createElement("text", {
    x: 158,
    y: 98,
    fontSize: 9.5,
    fill: "#8AA0AE",
    textAnchor: "end"
  }, "31 in stock"), /*#__PURE__*/React.createElement("path", {
    d: "M10 106 H160",
    stroke: "#E9EFF2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 85,
    y: 118,
    fontSize: 9.5,
    fontWeight: 600,
    fill: "#8AA0AE",
    textAnchor: "middle"
  }, "Edit"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(378,100)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 124,
    rx: 11,
    fill: "#FFFFFF",
    stroke: "#E9EFF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 9,
    width: 150,
    height: 56,
    rx: 8,
    fill: "#F7FAFB"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(85,38)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-19,-24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 6 q6 -4 12 0 q6 4 12 0 q6 -4 12 0 v36 q-6 4 -12 0 q-6 -4 -12 0 q-6 4 -12 0z",
    fill: "#E88B45"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 6 q6 -4 12 0 q6 4 12 0 q6 -4 12 0 v10 h-36z",
    fill: "#D9703A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 20,
    width: 24,
    height: 5,
    rx: 2.5,
    fill: "#fff",
    opacity: 0.9
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 29,
    width: 16,
    height: 3.5,
    rx: 1.75,
    fill: "#fff",
    opacity: 0.55
  }))), /*#__PURE__*/React.createElement("text", {
    x: 12,
    y: 82,
    fontSize: 12,
    fontWeight: 600,
    fill: "#14344B"
  }, "Chippy"), /*#__PURE__*/React.createElement("text", {
    x: 12,
    y: 98,
    fontSize: 13,
    fontWeight: 700,
    fill: "#14344B"
  }, "\u20B120"), /*#__PURE__*/React.createElement("text", {
    x: 158,
    y: 98,
    fontSize: 9.5,
    fill: "#8AA0AE",
    textAnchor: "end"
  }, "16 in stock"), /*#__PURE__*/React.createElement("path", {
    d: "M10 106 H160",
    stroke: "#E9EFF2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 85,
    y: 118,
    fontSize: 9.5,
    fontWeight: 600,
    fill: "#8AA0AE",
    textAnchor: "middle"
  }, "Edit"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(12,234)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 124,
    rx: 11,
    fill: "#FFFFFF",
    stroke: "#E9EFF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 9,
    width: 150,
    height: 56,
    rx: 8,
    fill: "#F7FAFB"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(85,38)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-12,-28)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 0,
    width: 10,
    height: 7,
    rx: 2,
    fill: "#C8483A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 7 h14 a3 3 0 0 1 3 3 v6 l2 6 v31 a6 6 0 0 1 -6 6 h-12 a6 6 0 0 1 -6 -6 v-31 l2 -6 v-6 a3 3 0 0 1 3 -3z",
    fill: "#5E3A2C",
    stroke: "#4A2C21",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 26,
    width: 24,
    height: 16,
    rx: 2,
    fill: "#C8483A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 32,
    width: 15,
    height: 4,
    rx: 2,
    fill: "#fff",
    opacity: 0.9
  }))), /*#__PURE__*/React.createElement("text", {
    x: 12,
    y: 82,
    fontSize: 12,
    fontWeight: 600,
    fill: "#14344B"
  }, "Coke Mismo"), /*#__PURE__*/React.createElement("text", {
    x: 12,
    y: 98,
    fontSize: 13,
    fontWeight: 700,
    fill: "#14344B"
  }, "\u20B125"), /*#__PURE__*/React.createElement("text", {
    x: 158,
    y: 98,
    fontSize: 9.5,
    fill: "#8AA0AE",
    textAnchor: "end"
  }, "24 in stock"), /*#__PURE__*/React.createElement("path", {
    d: "M10 106 H160",
    stroke: "#E9EFF2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 85,
    y: 118,
    fontSize: 9.5,
    fontWeight: 600,
    fill: "#8AA0AE",
    textAnchor: "middle"
  }, "Edit"))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(195,234)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 124,
    rx: 11,
    fill: "#FFFFFF",
    stroke: "#E9EFF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 9,
    width: 150,
    height: 56,
    rx: 8,
    fill: "#F7FAFB"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(85,38)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14,-28)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 0,
    width: 4,
    height: 22,
    rx: 2,
    fill: "#2E9B9B",
    transform: "rotate(12 19 11)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14,
    cy: 12,
    rx: 15,
    ry: 4.5,
    fill: "#DDE5E9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-1 12 h30 l-4 38 a5 5 0 0 1 -5 4 h-12 a5 5 0 0 1 -5 -4z",
    fill: "#F2F7F8",
    stroke: "#DDE5E9",
    strokeWidth: 1.4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 21 h26 l-3 29 a4 4 0 0 1 -4 3 h-12 a4 4 0 0 1 -4 -3z",
    fill: "#8CC79B"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 14,
    cy: 21,
    rx: 13,
    ry: 3.4,
    fill: "#B6DEBE"
  }))), /*#__PURE__*/React.createElement("text", {
    x: 12,
    y: 82,
    fontSize: 12,
    fontWeight: 600,
    fill: "#14344B"
  }, "Iced matcha"), /*#__PURE__*/React.createElement("text", {
    x: 12,
    y: 98,
    fontSize: 13,
    fontWeight: 700,
    fill: "#14344B"
  }, "\u20B1120"), /*#__PURE__*/React.createElement("text", {
    x: 158,
    y: 98,
    fontSize: 9.5,
    fill: "#8AA0AE",
    textAnchor: "end"
  }, "6 in stock"), /*#__PURE__*/React.createElement("path", {
    d: "M10 106 H160",
    stroke: "#E9EFF2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 85,
    y: 118,
    fontSize: 9.5,
    fontWeight: 600,
    fill: "#8AA0AE",
    textAnchor: "middle"
  }, "Edit"))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(378,234)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 170,
    height: 124,
    rx: 11,
    fill: "#FFFFFF",
    stroke: "#E9EFF2"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 9,
    width: 150,
    height: 56,
    rx: 8,
    fill: "#F7FAFB"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(85,38)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-21,-28)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 14,
    width: 42,
    height: 28,
    rx: 5,
    fill: "#EFC272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3 14 q18 -14 36 0z",
    fill: "#DFA84E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 14,
    width: 42,
    height: 6,
    rx: 3,
    fill: "#DFA84E"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 25,
    width: 12,
    height: 10,
    rx: 2.5,
    fill: "#fff",
    opacity: 0.85
  }), /*#__PURE__*/React.createElement("rect", {
    x: 23,
    y: 25,
    width: 12,
    height: 10,
    rx: 2.5,
    fill: "#fff",
    opacity: 0.6
  }))), /*#__PURE__*/React.createElement("text", {
    x: 12,
    y: 82,
    fontSize: 12,
    fontWeight: 600,
    fill: "#14344B"
  }, "Breakfast meal"), /*#__PURE__*/React.createElement("text", {
    x: 12,
    y: 98,
    fontSize: 13,
    fontWeight: 700,
    fill: "#14344B"
  }, "\u20B1150"), /*#__PURE__*/React.createElement("text", {
    x: 158,
    y: 98,
    fontSize: 9.5,
    fill: "#8AA0AE",
    textAnchor: "end"
  }, "12 in stock"), /*#__PURE__*/React.createElement("path", {
    d: "M10 106 H160",
    stroke: "#E9EFF2",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 85,
    y: 118,
    fontSize: 9.5,
    fontWeight: 600,
    fill: "#8AA0AE",
    textAnchor: "middle"
  }, "Edit"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStock);
export default __webpack_public_path__ + "static/media/stock.f3423b30a73a15826ecc38b9f3c5a915.svg";
export { ForwardRef as ReactComponent };